import { render, staticRenderFns } from "./prepare-personal.vue?vue&type=template&id=bf8d4532"
import script from "./prepare-personal.vue?vue&type=script&lang=js"
export * from "./prepare-personal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports